import { createEntitiesIndexSelector } from '@iconik-io/shared-lib/src/redux/entities_index/selectors';

export const selectFileSetsByAssetId = createEntitiesIndexSelector(
  'file_sets',
  'asset_id',
);

export const selectFileSetsByFormatId = createEntitiesIndexSelector(
  'file_sets',
  'format_id',
);
